import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";
import { listAllServiceCategories } from "../../components/api/Scheduling/serviceCategories";
import { onError } from "./onError";

export const serviceCategoryKeys = {
  all: (organizationRef, active) => ["scheduling-service-categories", organizationRef, active],
};

export function useServiceCategoriesQuery({ organizationRef, active, practitionerRef, scope, excludedOrganizationRefs, onSuccess, enabled = true }) {
  return useQuery(
    [...serviceCategoryKeys.all(organizationRef, active), scope, excludedOrganizationRefs, practitionerRef],
    ({ signal, consistency }) =>
      listAllServiceCategories({
        organizationRef,
        scope,
        practitionerRef,
        excludedOrganizationRefs,
        limit: 500, signal, consistency,
        ...(active === true || active === false ? { active } : {}),
      }),
    {
      enabled: !!organizationRef && enabled,
      keepPreviousData: false,
      staleTime: 60000, refetchOnWindowFocus: false, retry: false,
      onSuccess,
      onError,
    }
  );
}
